import { EventEmitter, Inject, Injectable } from "@angular/core";
import { FormControlStatus, FormGroup, Validators } from "@angular/forms";
import {
  BaseFpxComponentState,
  BaseFpxFormHelper,
  BaseFpxPostSubmitInterceptor,
  CriteriaQuery,
  RoutingInfo,
} from "@fpx/core";
import {
  BaseFpxChangeHandler,
  BaseFpxEventHandler,
  BaseFpxLoadFormHandler,
  FindByKeyFn,
  HttpRequest,
} from "@common/models";
import { CreditCardfilter } from "./credit-card-filter.model";
import moment from "moment";
import { API_DATE_FORMAT } from "@common/constants";
import { any } from "@amcharts/amcharts4/.internal/core/utils/Array";
import {
  MatDialogRef,
  MatDialog,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
// import { AccountsService } from "src/app/services/accounts/accounts.service";
import { CreditCardService } from "src/app/services/credit-card.service";
// import { CasatransactionService } from "../casatransaction-service/casatransaction.service";
import { CreditCardFilterComponent } from "./credit-card-filter.component";
import { CreditCardfilterService } from "./credit-card-filter.service";
import { CommonService } from "src/app/common.service";
import { FileOpenerService } from "src/app/services/mobile/file-opener.service";
import { IPopupScreenData } from "src/app/common/models/popup-screen-data.model";
import { DepositService } from "src/app/deposits/services/deposits.service";

export class CreditCardFilterFormState extends BaseFpxComponentState {
  showSuggestion: boolean = true;
  showReset: boolean;
  ismonthOrDate: string = "MINISTATEMENT";
  isDownloadFormat: string;

  fromMinDate: Date;
  toMinDate: Date;
  maxDate: Date;
  billingPeriod: string;
 
}

@Injectable()
export class CreditCardFilterFormHelper extends BaseFpxFormHelper<CreditCardFilterFormState> {
  accountNumber: any;
  // constructor() {
  //   super(new CASATransactionFilterFormState());
  // }
  constructor(
    private creditCardfilterService: CreditCardfilterService, 
    private processService: ProcessShellService,
   // private _casatransactionService: CasatransactionService,
    private _creditCardService: CreditCardService,
    private _commonService: CommonService,
    private _fileOpner: FileOpenerService,
    private _matDialogRef: MatDialogRef<CreditCardFilterComponent>,
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData
  ) {
    super(new CreditCardFilterFormState());
  }


  override doPreInit(): void {
    this.addChangeHandler("transactionPeriod", this.dotransactionPeriodChange);
    this.addChangeHandler("period", this.doperiodChange);

    this.addChangeHandler(
      "displayDownloadFormat",
      this.dodisplayDownloadFormatChange
    );


  }
  override doPostInit(): void {
    let data = this._creditCardService.popupData;
    this.accountNumber = data.contractNumber;
    this._creditCardService.popupData = undefined;

    this._commonService.contractnumber=data.contractNumber;
    this.initializeForm();
  }

  initializeForm() {
    this.formGroup.get("transactionPeriod").setValue("0",{eventEmit:false});
    this.formGroup.get("displayDownloadFormat").setValue("1",{eventEmit:false});


    console.log("accountNumberCasa", this.accountNumber);
    
    if(this._creditCardService.casaTrxFilterData.length>0){
      let filterData = this._creditCardService.casaTrxFilterData.find(x => x.accountNumber === this.accountNumber);
      if(filterData){
        this.formGroup.controls['transactionPeriod'].patchValue(filterData.filterPayload?.transactionPeriod);
        // this.formGroup.patchValue(filterData.filterPayload,{emitEvent:true});
        
        this.formGroup.controls['displayDownloadFormat'].patchValue(filterData.filterPayload?.displayDownloadFormat);

        if(filterData.filterPayload?.transactionPeriod === '1'){
          //temp fix need to change
          this.formGroup.controls['period'].patchValue(filterData.filterPayload.period);
          setTimeout(() => {
            this.formGroup.controls['month'].patchValue(filterData.filterPayload.month);
          }, 300);  
        }else if(filterData.filterPayload.transactionPeriod === '2'){
          //temp fix need to change
          this.formGroup.controls['from'].patchValue(filterData.filterPayload.from);
          setTimeout(() => {
            this.formGroup.controls['to'].patchValue(filterData.filterPayload.to);
          }, 300);
        }
      }
    }
  }

  

  private dotransactionPeriodChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
  ) => {
    // WRITE CODE HERE TO HANDLE

    // formGroup.controls["dodisplayDownloadFormatChange"].reset("", { emitEvent: false });
    // formGroup.controls["dotransactionPeriodChange"].reset("", { emitEvent: false });

    if (value == "2") {
      this.state.ismonthOrDate = "PERIOD";
      this.state.isDownloadFormat = "PDF";
    }
    else {
      this.state.ismonthOrDate = "";
      this.state.isDownloadFormat = "";
    }
    
    this.setupFormValidation(value[0])
    
    this.setupFormValidation(value[0])
  };

  private doperiodChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: Array<any>,
    formGroup: FormGroup
  ) => {
    // WRITE CODE HERE TO HANDLE
   // formGroup.controls["from"].reset();
    //formGroup.controls["to"].reset();
    //formGroup.controls["month"].reset();
  };
 
 
  private dodisplayDownloadFormatChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: Array<any>,
    formGroup: FormGroup
  ) => {
    // WRITE CODE HERE TO HANDLE
    // formGroup.controls["dodisplayDownloadFormatChange"].reset("", { emitEvent: false });
    // formGroup.controls["dotransactionPeriodChange"].reset("", { emitEvent: false });
  };

  public override preSubmitInterceptor(payload: CreditCardfilter): any {
    // WRITE CODE HERE TO HANDLE

     /** Set the casa transaction filter START*/
     let isFilterAlleadyAbl = this._creditCardService.casaTrxFilterData.find(x => x.accountNumber===this.accountNumber);
     if(isFilterAlleadyAbl){
      var foundIndex = this._creditCardService.casaTrxFilterData.findIndex(x => x.accountNumber===this.accountNumber);
      this._creditCardService.casaTrxFilterData[foundIndex] = {accountNumber:this.accountNumber,filterPayload:payload};
     }else{
      this._creditCardService.casaTrxFilterData.push({accountNumber:this.accountNumber,filterPayload:payload})
     }

     if(payload.transactionPeriod=="0"){
      const pos = this._creditCardService.casaTrxFilterData.findIndex(x => x.accountNumber===this.accountNumber);
      if (pos >= 0){
        this._creditCardService.casaTrxFilterData.splice(pos, 1);
      }      
     }
     /** Set the casa transaction filter END*/

    payload.contractNumber = this.accountNumber;
    payload.fileType = payload.displayDownloadFormat == "2" ? "PDF" : "";
   
if (payload.transactionPeriod == "0") {
      payload.billingPeriod = "1";
    } else if (payload.transactionPeriod == "1") {
      payload.billingPeriod = "2";
    } else {
      payload.billingPeriod = "3"; 
    }
    
if (payload.displayDownloadFormat == "2") {
      payload.viewType = "2";
    } else{
      payload.viewType = "1";
    }

    return payload;
  }

  setupFormValidation(value) {
    if (value == '2') {
this.formGroup.get('period').enable({ emitEvent: false });
 this.formGroup.get('period').addValidators(Validators.required);
 
    } else {
      this.formGroup.get('period').disable({ emitEvent: false });
      this.formGroup.get('period').removeValidators(Validators.required);
    }

  }

  public override postSubmitInterceptor(response: any): RoutingInfo {
    let routingInfo: RoutingInfo = new RoutingInfo();
    // WRITE CODE HERE TO HANDLE
    return routingInfo;
  }
  // reset() {
  //   this.formGroup.reset();
  //   this.formGroup.get('transactionPeriod').patchValue('0',{emitEvent : false});
  //   this.formGroup.get('displayDownloadFormat').patchValue('1',{emitEvent : false});
  // }
  submitForm() {
    let payload = this.preSubmitInterceptor(this.formGroup.value);
    if(payload.billingPeriod!='3') {
      payload.fileType = "";
     }
    if (payload.fileType == "PDF") {
      this.creditCardfilterService.createFilter(payload).subscribe({
        next: (response: any) => {
          this._commonService.hideSpinner();
          if (this._commonService.isHybrid()) {
            this._fileOpner.openPDF(
              response,
              "application/pdf",
              "TransactionDetails.pdf"
            );
          } else {
            let documentURL = URL.createObjectURL(
              new Blob([response.body], { type: "application/pdf" })
            );
            const downloadLink = document.createElement("a");
            downloadLink.href = documentURL;
            const fileName = "TransactionDetails";
            downloadLink.download = fileName;
            downloadLink.click();
          }
        },error:(error:any)=>{
          this._commonService.hideSpinner();
        },
      });
      this.matDialog.closeAll();
    } else {
      const criteria: CriteriaQuery = new CriteriaQuery();
    
      criteria.addQueryparam("contractNumber", payload.contractNumber);
      // criteria.addQueryparam("fileType", "VOS");
      criteria.addQueryparam("billingPeriod", payload.billingPeriod);
      if(payload.billingPeriod=='3') {
        criteria.addQueryparam("viewType", payload.viewType);
        criteria.addQueryparam("period", payload.period);
      } else {
        criteria.addQueryparam("viewType", '1');
      }
      this._creditCardService.popupData = { criteria: criteria };
      this.matDialog.closeAll();
    }
  }


  reset() {
    // this.initializeForm();
    this.formGroup.get("transactionPeriod").setValue("0",{eventEmit:false});
    this.formGroup.get("displayDownloadFormat").setValue("1",{eventEmit:false});

    console.log("accountNumberCasa", this.accountNumber);
    // this.submitForm();
  }
}
